const checkPhone = (rule, value, callback) => {
  const _this = this
  const reg = /^1[345789]\d{9}$/
  if (!reg.test(value)) {
    callback(new Error(_this.$t('validMobileInfo')))
  } else {
    callback()
  }
}

const getCookie = (cname) => {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

// 设置cookie,增加到vue实例方便全局调用
export const setCookie = (cName, value, expiredays) => {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  let domain = ''
  try {
    if (window.location.host.indexOf('glodon.com') > -1) {
      domain = 'domain=glodon.com;'
    }
  } catch (error) {}
  document.cookie = cName + '=' + escape(value) + ((expiredays == null) ? '' : 'expires=' + exdate.toGMTString()) + ';' + domain + 'path=/;secure=true;sameSite=none;'
  // document.cookie = cName + '=' + escape(value) + ((expiredays == null) ? '' : 'expires=' + exdate.toGMTString()) + ';' + 'path=/;secure=true;sameSite=none;'
}

// 判断是否IE浏览器
export const isIE = () => {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true } else { return false }
}

const getTenantThemeCodeByPath = (path) => {
  const arrPath = path.split('/')
  if (arrPath[4] === 'custom' && arrPath[5]) {
    return arrPath[5]
  }
  return null
}

const getQueryString = (name, url) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r
  if (url) {
    r = url.split('?')[1] && url.split('?')[1].match(reg)
  } else {
    r = window.location.search.substr(1).match(reg)
  }

  if (r != null) return unescape(r[2])
  return null
}

// 网易易盾
export const captchaId = 'f48c8384d76e43669e25f1f9f95ecbfc'
// 短信登录加密字段
const appId = 'dcost_124937267304'

// 短信登录防刷标识
const aes = (time, mobile) => {
  // node 包
  const crypto = require('crypto')
  // 后端约定的id

  const data = 'appId:' + appId + ',mobile:' + mobile + ',t:' + time
  // 后端约定的key 和 iv
  const key = '75784fc6914782a8'
  const iv = '75784fc6914782a8'
  const cipher = crypto.createCipheriv('aes-128-cbc', key, iv)
  const cipherChunks = []
  cipherChunks.push(cipher.update(data, 'utf8', 'base64'))
  cipherChunks.push(cipher.final('base64'))
  const str = cipherChunks.join('')
  const md5 = crypto.createHash('md5')
  md5.update(str)
  const scret = md5.digest('hex')
  return scret
}
export default {
  checkPhone,
  getCookie,
  getQueryString,
  getTenantThemeCodeByPath,
  appId,
  aes
}
